module OnlineDPR.Application.Client.Report.EditDpr

open Fable.React
open Fable.React.Props

open OnlineDPR.Application.Client.Components
open OnlineDPR.Application.Client.Translations
open OnlineDPR.Application.Client.Report.Types

open OnlineDPR.Application.Shared
open OnlineDPR.Application.Shared.Translations

let editDprError (m:EditRowModel) =
    match m.Date.ValidationMessage, m.ErrorMessage with
    | Some s, _ -> validationMessage s |> errorMessage
    | None, Some s -> errorMessage s
    | None, None -> []
    |> ofList

let renderEditDpr model dispatch =
    let title = str CurrentTranslations.Translations.[TranslationKey.ControlPanel_Dpr_EditDpr_Title]
    let content = div [ ClassName "form-inline" ]
                      (match model.EditDpr.PendingRequest with
                      | true -> [ spinner ]
                      | false -> [ InlineFormFieldComponent model.EditDpr.ClubNumber (EditDprClubSelected >> dispatch)
                                   InlineFormFieldComponent model.EditDpr.Date (EditDprDateSelected >> dispatch)
                                   button [ ClassName "btn btn-primary"
                                            OnClick (fun _ -> dispatch EditDprRequested)]
                                          [ str CurrentTranslations.Translations.[TranslationKey.ControlPanel_Dpr_EditDpr_SubmitButtonText] ]
                                   editDprError model.EditDpr ] )
    toggleCard title content model.ShowEditDpr (fun _ -> dispatch ToggleShowEditDpr )